module.exports = __webpack_public_path__ + "img/full1-min.6254b4c2.png";